/** Open the notification flyout from anywhere (closes overlays that would cover it). */
export const INBOX_OPEN_EVENT = 'wapharma-inbox-open';

export function requestInboxOpen() {
  window.dispatchEvent(new Event(INBOX_OPEN_EVENT));
}
